module.exports = __webpack_public_path__ + "assets/img/247601.f298cb32.png";